import url from '../svg/sprites.svg';

const SvgIcon = (props) => (
    <svg  className={`sicon icon-${props.clName}`}  style={props.style} >
      <use href={`${url}#${props.icon}`}  />
    </svg>
  );

  export default SvgIcon;